import { SummaryRow, SummaryView } from '@salecycle/ui-component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useNewRoleState } from '../../context/useNewRoleContext';
import { getStepRoute } from '../../data/NewRoleConstants';

export const NewRoleSummary: React.FC = () => {
  const { t } = useTranslation();
  const { name, permissions, users } = useNewRoleState();
  const { push } = useHistory();
  const enabledPermissions = Object.keys(permissions).filter(name => !!permissions[name]);

  return (
    <SummaryView heading={t('newRole.summary.heading')} subHeading={t('newRole.summary.subheading')}>
      <SummaryRow
        buttonText={t('newRole.summary.summaryRows.roleCreation.buttonText')}
        description={t('newRole.summary.summaryRows.roleCreation.description', {
          roleName: name,
        })}
        heading={t('newRole.summary.summaryRows.roleCreation.heading')}
        onClick={() => push(getStepRoute(1))}
      />
      <SummaryRow
        buttonText={t('newRole.summary.summaryRows.permissions.buttonText')}
        description={t('newRole.summary.summaryRows.permissions.description', {
          roleName: name,
          permissionsString: enabledPermissions
            .map(name => t(`newRole.roleSetup.permissionsLabels.${name}`))
            .join(', '),
        })}
        heading={t('newRole.summary.summaryRows.permissions.heading')}
        onClick={() => push(getStepRoute(1))}
      />
      <SummaryRow
        buttonText={t('newRole.summary.summaryRows.usersAdded.buttonText')}
        description={
          users.length > 0
            ? t('newRole.summary.summaryRows.usersAdded.description', {
                usersString: users.map(val => val.label).join(', '),
              })
            : t('newRole.summary.summaryRows.usersAdded.noUsersAddedDescription')
        }
        heading={t('newRole.summary.summaryRows.usersAdded.heading')}
        onClick={() => push(getStepRoute(1))}
      />
    </SummaryView>
  );
};
